/*
 * Os dois mapas-base do observatório, servidos por provedores de fora: Ruas, o
 * mapa padrão do OpenStreetMap, e Satélite, as imagens do World Imagery da
 * Esri. Os dois são tiles raster públicos, sem chave de acesso, pedidos pelo
 * navegador direto ao provedor.
 *
 * Endereço e atribuição moram só aqui. Trocar de provedor é trocar esta
 * constante e os dois hosts da CSP da borda
 * (infra/nginx/templates/default.conf.template); a decisão e o que se recusou
 * estão em docs/adr/0013-mapa-base-de-provedores-externos.md.
 */

export type IdMapaBase = 'ruas' | 'satelite'

export interface MapaBaseExterno {
  id: IdMapaBase
  /** O texto do botão que liga este mapa-base. */
  nome: string
  /** Modelo de URL dos tiles, como o MapLibre espera. */
  tiles: string[]
  /** A atribuição que o provedor exige, mostrada no canto do mapa. */
  atribuicao: string
  /** Último nível com imagem nos dois provedores. */
  zoomMaximo: number
}

export const MAPAS_BASE: Record<IdMapaBase, MapaBaseExterno> = {
  ruas: {
    id: 'ruas',
    nome: 'Ruas',
    tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
    atribuicao: '<a href="https://www.openstreetmap.org/copyright">© OpenStreetMap</a>',
    zoomMaximo: 19,
  },
  satelite: {
    id: 'satelite',
    nome: 'Satélite',
    // A Esri ordena o endereço por linha e coluna: {y} antes de {x}.
    tiles: [
      'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    ],
    atribuicao: 'Imagens Esri, Maxar, Earthstar Geographics e comunidade de usuários de SIG',
    zoomMaximo: 19,
  },
}

/** A ordem dos botões do painel. */
export const IDS_DOS_MAPAS_BASE: readonly IdMapaBase[] = ['ruas', 'satelite']

/** Ruas é o mapa-base de quem abre o observatório. */
export const MAPA_BASE_INICIAL: IdMapaBase = 'ruas'
